import { render } from "./DateSelector.vue?vue&type=template&id=ced7565a&ts=true"
import script from "./DateSelector.vue?vue&type=script&lang=ts"
export * from "./DateSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__